import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    UnavailableDateService,
    UnavailableDatePopupService,
    UnavailableDateComponent,
    UnavailableDateDetailComponent,
    UnavailableDateDialogComponent,
    UnavailableDatePopupComponent,
    UnavailableDateDeletePopupComponent,
    UnavailableDateDeleteDialogComponent,
    unavailableDateRoute,
    unavailableDatePopupRoute,
    UnavailableDateResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...unavailableDateRoute,
    ...unavailableDatePopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        UnavailableDateComponent,
        UnavailableDateDetailComponent,
        UnavailableDateDialogComponent,
        UnavailableDateDeleteDialogComponent,
        UnavailableDatePopupComponent,
        UnavailableDateDeletePopupComponent,
    ],
    entryComponents: [
        UnavailableDateComponent,
        UnavailableDateDialogComponent,
        UnavailableDatePopupComponent,
        UnavailableDateDeleteDialogComponent,
        UnavailableDateDeletePopupComponent,
    ],
    providers: [
        UnavailableDateService,
        UnavailableDatePopupService,
        UnavailableDateResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiUnavailableDateModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/unavailable-date/unavailable-date.module.ts